(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/products-grid-widget/assets/javascripts/prepare-tipsen-item.js') >= 0) return;  svs.modules.push('/components/sport/products-grid-widget/assets/javascripts/prepare-tipsen-item.js'); "use strict";



(function () {
  'use strict';

  const FALLBACK_PRODUCT_BRANDING = 'topptipset';
  const GRID_ITEM_SIZES = {
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large'
  };
  const trinidad = svs.isServer ? require('trinidad-core').core : svs.core;
  const dateFnsImport = svs.isServer ? require('date-fns') : dateFns;
  const {
    differenceInCalendarDays,
    format: formatDate
  } = dateFnsImport;
  const {
    Currency: formatCurrency
  } = svs.isServer ? trinidad.components.require('utils', 'format').api : svs.utils.format;
  const mockableImports = {
    queryDrawDataAsync: svs.isServer ? 
    require('./query-draw-data-async.es6').queryDrawDataAsync : svs.sport.productsGridWidget.queryDrawDataAsync
  };

  async function prepareTipsenItem(_ref) {
    let {
      itemConfig,
      isMobile,
      size,
      trackingPrefix,
      widgetId,
      req
    } = _ref;
    const {
      productsByPriority: products
    } = itemConfig;

    if (size !== GRID_ITEM_SIZES.LARGE) {
      throw new Error("prepareTipsenItem() failed: Size \"".concat(size, "\" not supported, missing in CMS-config"));
    }

    const isLoggedInAsAdmin = svs.isServer ? 
    req.userSession.hasRole(req.userSession.roles.INTERNAL) : svs.core.userSession.hasRole(svs.core.userSession.roles.INTERNAL);
    const drawData = await mockableImports.queryDrawDataAsync({
      itemConfig,
      cacheKey: "productsGridTipsen-".concat(widgetId),
      req
    });
    const {
      closeTime,
      jackpot,
      extraMoney
    } = drawData;
    const branding = drawData.branding || FALLBACK_PRODUCT_BRANDING;
    const product = products.find(item => item.branding === branding);

    if (!product && branding === FALLBACK_PRODUCT_BRANDING) {
      throw new Error("prepareTipsenItem() failed - Can't use fallback product, invalid CMS config");
    }

    const title = _getJackpotText({
      jackpot,
      extraMoney,
      isMobile
    }) || product.title;
    const subTitle = _getCloseTimeText({
      closeTime,
      isMobile
    }) || product.subTitle;

    const logoText = _getLogoText({
      jackpot,
      extraMoney
    });

    const {
      images,
      filterOpacity,
      gradientOpacity,
      urlMapping
    } = product;
    const imageMobile = images.mobileLarge;
    const imageDesktop = images.desktopLarge;

    const _getWarningMessage = () => {
      if (!drawData.branding) {
        return 'API request failed - fallback-product active';
      }

      const targetsWithoutImageData = [imageMobile ? '' : 'mobile', imageDesktop ? '' : 'desktop'].filter(s => s);

      if (targetsWithoutImageData.length > 0) {
        return "Image missing (".concat(targetsWithoutImageData.join(', '), ")");
      }

      if (!urlMapping) {
        return 'URL-mapping missing';
      }

      return null;
    };

    const warning = isLoggedInAsAdmin ? _getWarningMessage() : null;
    const trackingString = "".concat(trackingPrefix, "/tipsen-product/").concat(branding);
    return {
      branding,
      imageMobile,
      imageDesktop,
      filterOpacity,
      gradientOpacity,
      title,
      subTitle,
      logoText,
      urlMapping,
      size,
      warning,
      trackingString
    };
  }

  const WEEKDAY_NAMES_IN_SWEDISH = ['söndag', 'måndag', 'tisdag', 'onsdag', 'torsdag', 'fredag', 'lördag'];

  function _getCloseTimeText(_ref2) {
    let {
      closeTime,
      isMobile
    } = _ref2;

    if (!closeTime) {
      return null;
    }

    const now = new Date();
    const time = new Date(closeTime);
    const diffDays = differenceInCalendarDays(time, now);

    if (time > now && diffDays < 7) {
      const dayText = ['idag', 'imorgon'][diffDays] || WEEKDAY_NAMES_IN_SWEDISH[time.getDay()];
      const timeText = "kl&nbsp;".concat(formatDate(time, 'H:mm'));
      return "Spelstopp ".concat(dayText, " ").concat(timeText);
    }

    return null;
  }


  function _getJackpotText(_ref3) {
    let {
      jackpot,
      extraMoney,
      isMobile
    } = _ref3;

    if (jackpot) {
      return "".concat(formatCurrency(jackpot), " ").concat(isMobile ? 'kr' : 'kronor');
    }

    return null;
  }


  function _getLogoText(_ref4) {
    let {
      jackpot,
      extraMoney
    } = _ref4;

    if (jackpot) {
      return 'Jackpot!';
    }

    return null;
  }

  if (svs.isServer) {
    module.exports = {
      prepareTipsenItem
    };
  } else {
    setGlobal('svs.sport.productsGridWidget.prepareTipsenItem', prepareTipsenItem);
    setGlobal('svs.sport.productsGridWidget.testInternals.prepareTipsenItem.getMockableImports', () => mockableImports);
  }
})();
 })(window);